import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "src/app/core/auth/auth.guard";
import { CanActivateChildGuard } from "src/app/core/guards/can-activate-child.guard";
import { AddLotComponent } from "./add-lot/add-lot.component";

const routes: Routes = [{
  path: "", component: AddLotComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContractLotRoutingModule { }
